import { notification } from 'antd';

notification.config({ placement: 'bottomLeft' });

export const Notify = notification;
